(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , venueSchema = require('../venue/schema')
  , locationSchema = require('./location-schema')
const required = require('@clocklimited/validity-required')

module.exports = function () {

  return schemata(
    { showId:
      { type: String
      }
    , date:
      { type: Date
      , validators: { all: [ required ] }
      }
    , location:
      { type: locationSchema
      , validators: { all: [ required ] }
      }
    , venue:
      { type: venueSchema
      , validators: { all: [ required ] }
      }
    , currency:
      { type: String
      , validators: { all: [ required ] }
      }
    , status:
      { type: String
      }
    , driveTime:
      { type: Number
      }
    , distance:
      { type: Number
      }
    , driveTimeText:
      { type: String
      }
    , distanceText:
      { type: String
      }
    , ticketPrice:
      { type: String
      }
    , offer:
      { type: String
      }
    , offerDescription:
      { type: String
      }
    , walkout:
      { type: String
      }
    , promoter:
      { type: Object
      }
    , notes:
      { type: String
      }
    , costDocument:
      { type: Object
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/tour/tour-show-schema.js","/components/service/tour")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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